module.exports = __webpack_public_path__ + "assets/img/shoton.webp?0d9f909942e987a58268dc3831e68e8b";